import { useState } from "react";
import axios from "axios";
import styles from "../assets/css/AddPromotion.module.css";
import { BASE_URL } from "../constants/constants";

const AddPromotionThirdType = ({ onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    title: "",
    bannerDescription: "",
    fullDescription: "",
    priceLimit: "",
    tripLimit: "",
    startDate: "",
    deadline: "",
  });

  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      priceLimit: Number(formData.priceLimit),
      tripLimit: Number(formData.tripLimit),
      isActive: true,
      isPublic: true,
      promotionType: "type_2",
    };

    try {
      await axios.post(`${BASE_URL}/v0/promotions`, payload, { headers });
      alert("Успешно добавлено!")
      onUpdate(); 
      onClose();
    } catch (error) {
      console.error("Ошибка при добавлении:", error.response?.data || error.message);
      alert("Ошибка при добавлении")
    }
  };

  return (
    <div className={styles.modal}>
      <form className={styles.container} onSubmit={handleSubmit}>
        <div className={styles.box}>
          <div className={styles.text}>Добавить</div>
          <img
            onClick={onClose}
            className={styles.closeicon}
            src="/images/close.svg"
            alt="close icon"
          />
        </div>
        <input
          className={styles.input}
          name="title"
          placeholder="Введите название"
          type="text"
          maxLength="100"
          value={formData.title}
          onChange={handleChange}
        />
        <input
          className={styles.input}
          name="bannerDescription"
          placeholder="Введите описание для баннера"
          type="text"
          maxLength="100"
          value={formData.bannerDescription}
          onChange={handleChange}
        />
        <textarea
          className={styles.input}
          name="fullDescription"
          placeholder="Введите полное описание"
          maxLength="500"
          value={formData.fullDescription}
          onChange={handleChange}
        />
        <div className={styles.dateWrapper}>
          <input
            className={styles.date}
            name="priceLimit"
            type="number"
            placeholder="Лимит цены"
            value={formData.priceLimit}
            onChange={handleChange}
          />
          <input
            className={styles.date}
            name="tripLimit"
            type="number"
            placeholder="Лимит поездок"
            value={formData.tripLimit}
            onChange={handleChange}
          />
        </div>
        <div className={styles.label}>Срок действия промокода</div>
        <div className={styles.dateWrapper}>
          <input
            className={styles.date}
            name="startDate"
            type="date"
            placeholder="Введите дату начала"
            value={formData.startDate}
            onChange={handleChange}
          />
          <input
            className={styles.date}
            name="deadline"
            type="date"
            placeholder="Введите дату окончания"
            value={formData.deadline}
            onChange={handleChange}
          />
        </div>
        <div className={styles.box1}>
          <button type="submit" className={styles.addbtn}>
            Добавить
          </button>
          <button type="button" onClick={onClose} className={styles.cancelbtn}>
            Отмена
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPromotionThirdType;
